import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "../components/Seo";

export default function NotFound() {
  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  return (
    <main
      data-testid="notfound-page"
      className="pt-32 md:pt-40 pb-24 md:pb-32 bg-[#F8F5EF] min-h-screen"
    >
      <Seo
        title="Seite nicht gefunden (404)"
        description="Die von Ihnen aufgerufene Seite existiert nicht. Zurück zur Startseite von Wertbild Immobilienfotografie."
        path="/404"
        noindex
      />

      <div className="container-x max-w-4xl">
        <div className="overline mb-6">Fehler 404</div>

        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#1A1A1A] tracking-tight font-light">
          Seite <span className="italic gold-text">nicht gefunden</span>.
        </h1>

        <p className="mt-8 max-w-2xl text-[15px] md:text-[17px] leading-[1.6] text-[#3A3A3A] font-light">
          Die aufgerufene Adresse existiert nicht oder wurde verschoben.
          Wählen Sie eine der folgenden Seiten oder kehren Sie zur Startseite zurück.
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
          <Link
            to="/"
            data-testid="notfound-cta-home"
            className="group inline-flex items-center justify-between px-6 py-4 bg-[#1A1A1A] text-[#F8F5EF] text-xs uppercase tracking-[0.2em] hover:bg-[#FFA500] hover:text-[#1A1A1A] transition-colors duration-300 font-medium"
          >
            Zur Startseite
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:rotate-45" />
          </Link>
          <Link
            to="/leistungen-preise/immobilienfotografie-preise"
            data-testid="notfound-cta-pricing"
            className="group inline-flex items-center justify-between px-6 py-4 border border-[#1A1A1A] text-[#1A1A1A] text-xs uppercase tracking-[0.2em] hover:bg-[#1A1A1A] hover:text-[#F8F5EF] transition-colors duration-300 font-medium"
          >
            Preise ansehen
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:rotate-45" />
          </Link>
        </div>

        <nav aria-label="Weitere Seiten" className="mt-14">
          <div className="overline mb-4">Weitere Seiten</div>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-[14px] font-light text-[#1A1A1A]">
            <li><Link to="/" className="hover:text-[#FFA500] transition-colors">Start</Link></li>
            <li><Link to="/leistungen-preise/immobilienfotografie-preise" className="hover:text-[#FFA500] transition-colors">Immobilienfotografie – Preise</Link></li>
            <li><Link to="/leistungen-preise/immobilienvideografie-preise" className="hover:text-[#FFA500] transition-colors">Immobilienvideografie – Preise</Link></li>
            <li><Link to="/blog" className="hover:text-[#FFA500] transition-colors">Blog</Link></li>
            <li><Link to="/impressum" className="hover:text-[#FFA500] transition-colors">Impressum</Link></li>
            <li><Link to="/datenschutz" className="hover:text-[#FFA500] transition-colors">Datenschutz</Link></li>
            <li><Link to="/agb" className="hover:text-[#FFA500] transition-colors">AGB</Link></li>
          </ul>
        </nav>
      </div>
    </main>
  );
}
